import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0026ff",
    },
    secondary: {
      main: "#f50057",
    },
    background: {
      default: "#f6f8fc",
    },
  },
  typography: {
    fontFamily: ["Raleway", "system-ui", "-apple-system", "sans-serif"].join(","),
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiCard: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        title: {
          fontSize: "1.05rem",
          fontWeight: 600,
        },
      },
    },
  },
});
